import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const NiosEditSubject = () => {
  const [niosClassNameId, setNiosClassNameId] = useState();
  const [niosSubjectName, setNiosSubjectName] = useState("");
  const [niosSubjectId, setNiosSubjectId] = useState();
  const [subjectUploadIcon, setSubjectUploadIcon] = useState(null);
  const [category, setCategory] = useState([]);
  const [selectCategory, setSelectCategory] = useState("");

  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  const handleAddCategory = () => {
    if (selectCategory && !category.includes(selectCategory)) {
      setCategory([...category, selectCategory]);
      setSelectCategory(""); // reset dropdown
    }
  };

  const handleRemoveCategory = (cat) => {
    setCategory(category.filter((item) => item !== cat));
  };

  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/niosSubject/${id}`)
      .then((response) => {
        setNiosSubjectId(response.data?._id);
        setNiosSubjectName(response.data?.subjectName);
        setNiosClassNameId(response.data?.niosClassId?._id);
        setSubjectUploadIcon(response.data?.icon);
        setCategory(response.data?.category);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [API_BASE_URL]);

  const handleAddNewSubject = () => {
    navigate("/nios-add-subject");
  };

  const handleViewAllSubjects = () => {
    navigate("/nios-all-subject");
  };
  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("subjectName", niosSubjectName);
    formData.append("icon", subjectUploadIcon);
    formData.append("niosClassId", niosClassNameId);
    category.forEach((cat) => {
      formData.append("category[]", cat);
    });
    axios
      .put(`${API_BASE_URL}/admin/niosSubject/${id}`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        alert("Subject Updated");
        navigate("/nios-all-subject");
      })
      .catch((error) => {
        console.log(error);
        alert("Error while updating subject.");
      });
  };
  return (
    <div id="add-subject-inner-wrapper">
      <div className="superheader">
        <div className="subjectHeaderdiv">
          <h5>Subject</h5>
          <div className="subjectdiv2">
            <button className="handleNewSubject" onClick={handleAddNewSubject}>
              + Add New Subject
            </button>
            <button className="allSubjects" onClick={handleViewAllSubjects}>
              All Subjects
            </button>
          </div>
        </div>

        <div className="form-sub-container mt-4" id="form">
          <h4 className="subject-detail">Edit Subject Details</h4>
          <form
            className="subject-detail-form"
            encType="multipart/form-data"
            onSubmit={handleSubmit}
          >
            <div className="input-group">
              <div style={{ paddingBottom: "10px" }}>
                <label className="label">Subject</label>
              </div>
              <input
                type="text"
                placeholder="Enter Subject"
                value={niosSubjectName}
                onChange={(e) => setNiosSubjectName(e.target.value)}
                required
              />
            </div>
            <div className="input-group">
              <div style={{ paddingBottom: "10px" }}>
                <label className="label">Upload Icon</label>
              </div>
              <input
                type="file"
                id="subject-upload-icon"
                multiple={false}
                onChange={(e) => {
                  const file = e.target.files[0]; // Access the first file
                  console.log(file);

                  if (file) {
                    setSubjectUploadIcon(file); // Store the file object, not the value
                  }
                }}
              />
            </div>

            <div className="input-group">
              <div style={{ paddingBottom: "10px" }}>
                <label className="label">Select Category</label>
              </div>
              <div style={{ display: "flex", gap: "10px" }}>
                <select
                  className="school-class-add-input-tag"
                  value={selectCategory}
                  onChange={(e) => setSelectCategory(e.target.value)}
                >
                  <option value="">-Select Category-</option>
                  <option
                    value="Assignment"
                    disabled={category.includes("Assignment")}
                  >
                    Assignment
                  </option>
                  <option
                    value="Exam_Notes"
                    disabled={category.includes("Exam_Notes")}
                  >
                    Exam Notes
                  </option>
                  <option
                    value="video_section"
                    disabled={category.includes("video_section")}
                  >
                    Video Section
                  </option>
                </select>
                <button
                  type="button"
                  onClick={handleAddCategory}
                  className="btn-s"
                >
                  Add
                </button>
              </div>
            </div>

            {/* Show selected categories with remove option */}
            {category.length > 0 && (
              <div className="selected-categories">
                <p style={{ marginBottom: "5px" }}>Selected Categories:</p>
                <ul>
                  {category.map((cat, index) => (
                    <li key={index} style={{ marginBottom: "5px" }}>
                      {cat.replaceAll("_", " ")}
                      <button
                        type="button"
                        onClick={() => handleRemoveCategory(cat)}
                        style={{
                          marginLeft: "10px",
                          background: "red",
                          color: "white",
                          border: "none",
                          padding: "2px 6px",
                          borderRadius: "4px",
                          cursor: "pointer",
                        }}
                      >
                        Remove
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            <div className="school-subj-form-btns">
              <button className="btn-search" type="submit">
                Save
              </button>
              <button
                className="btn-cancel"
                type="button"
                onClick={() => navigate("/school-all-subject")}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NiosEditSubject;
